import { DiscoverFeed } from "@/features";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";

export function DiscoverSectionPage() {
  const { section: sectionId } = useParams();
  const navigate = useNavigate();

  if (!sectionId) {
    navigate("/discover");
    return null;
  }

  useEffect(() => {
    window.scrollTo(0, 350);
  }, [sectionId]);

  return <DiscoverFeed sectionId={sectionId} />;
}
